import Modal from "../../../../utils/components/Modal";
const GroupViewModal = ({ show, hideModal, groupInfo }) => {
  return (
    <div>
      <Modal
        title="Group Information"
        modalSize="xl"
        show={show}
        setShow={hideModal}
      >
        <div className="row mb-4">
          {groupInfo &&
            Object.keys(groupInfo).map((key) => {
              return (
                <div className="col-12 col-md-6 text-center my-4" key={key}>
                  <p className="mb-1 fs-6">{key}</p>
                  <p className="fw-bold fs-5">{groupInfo[key]}</p>
                </div>
              );
            })}
        </div>
      </Modal>
    </div>
  );
};
export default GroupViewModal;
